<div class="flex-vertical gap-16">
  <div class="filters-container">
    <div class="flex-horizontal gap-16">
      @if (isFilterActive(operationDashboardFilterEnum.Partenaire)) {
        <oui-select-filter
          label="Partenaire"
          type="list"
          panelDirection="right"
          [listOptions]="partenaireOptions"
        [control]="partenaireControl"></oui-select-filter>
      }
      @if (isFilterActive(operationDashboardFilterEnum.BordereauDateEnvoi)) {
        <oui-date-picker
          [control]="dateEnvoiControl"
        label="Date d'envoi"></oui-date-picker>
      }

      @if (isFilterActive(operationDashboardFilterEnum.BordereauStatut)) {
        <oui-select-filter
          label="Statut"
          type="list"
          panelDirection="right"
          [listOptions]="bordereauStatutOptions"
        [control]="bordereauStatutControl"></oui-select-filter>
      }

      <!-- <oui-select-filter *ngIf="isFilterActive(operationDashboardFilterEnum.Partenaire)" label="Partenaires"
      type="list" panelDirection="left" listPlaceholder="Rechercher" [listOptions]="partenaireOptions"
    [control]="partenaireControl"></oui-select-filter> -->
  </div>
</div>
<div class="flex-horizontal gap-16">
  <oui-chip-list type="selection">
    @for (filter of filterStateMap | keyvalue; track filter) {
      @for (chip of filter.value.chips; track chip) {
        <oui-chip (remove)="onRemove(chip)">{{ chip.label }}</oui-chip>
      }
    }
  </oui-chip-list>
  @if (showClearFiltersButton) {
    <oui-button type="text" color="primary" (click)="onclearAllFilter()"
      >Effacer les filtres
    </oui-button>
  }
</div>
</div>
